import { styled } from "@givenwell/stitches";

export const PageInset = styled("div", {
  display: "flex",
  flexDirection: "column",
  paddingLeft: "calc(var(--layout-margin) + var(--safe-area-inset-left))",
  paddingRight: "calc(var(--layout-margin) + var(--safe-area-inset-right))",
});

export const ContentBlock = styled("div", {
  display: "flex",
  flexDirection: "column",
  paddingLeft: "calc(var(--layout-margin) + var(--safe-area-inset-left))",
  paddingRight: "calc(var(--layout-margin) + var(--safe-area-inset-right))",
  py: 16,
});
